import React from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody } from 'reactstrap';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Loading skeleton for the Trade Rule Show page.
 * Mirrors the layout of `TradeRuleShow/index.jsx`: breadcrumbs, heading,
 * and a timeline card skeleton.
 * @returns {React.ReactElement} Placeholder component.
 */
function Placeholder() {
  const intl = useIntl();

  const propertiesBreadcrumb = intl.formatMessage({
    id: 'trade_rule.trade_rule_show.placeholder.breadcrumbs.properties.label',
    defaultMessage: 'Properties',
  });
  const tradeRulesBreadcrumb = intl.formatMessage({
    id: 'trade_rule.trade_rule_show.placeholder.breadcrumbs.trade_rules.label',
    defaultMessage: 'Trade Rules',
  });
  const tradeRuleTitle = intl.formatMessage({
    id: 'trade_rule.trade_rule_show.placeholder.heading.trade_rule.label',
    defaultMessage: 'Trade Rule',
  });
  const showContext = intl.formatMessage({
    id: 'trade_rule.trade_rule_show.placeholder.heading.context.show.label',
    defaultMessage: 'Show',
  });

  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          { name: propertiesBreadcrumb, path: '/properties' },
          { name: <span className="placeholder placeholder-glow bg-darken" style={{ width: '10rem' }} /> },
          { name: tradeRulesBreadcrumb },
          { name: <span className="placeholder placeholder-glow bg-darken" style={{ width: '8rem' }} /> },
        ]}
      />
      <Heading title={tradeRuleTitle} context={showContext} />

      <Card className="mt-4 mb-4" aria-hidden="true">
        <CardBody>
          {[0, 1, 2, 3, 4].map((rowIdx) => (
            <div className="mb-3" key={`placeholder-timeline-row-${rowIdx}`}>
              <div className="mb-1">
                <span className="placeholder placeholder-glow bg-darken col-3" />
              </div>
              <span className="placeholder placeholder-glow bg-darken col-10" />
              <br />
              <span className="placeholder placeholder-glow bg-darken col-7" />
            </div>
          ))}
        </CardBody>
      </Card>
    </>
  );
}

export default Placeholder;
